import script from "./ReportInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReportInfo.vue?vue&type=script&lang=ts&setup=true"

import "./ReportInfo.vue?vue&type=style&index=0&id=7b1d166e&lang=sass"

const __exports__ = script;

export default __exports__